import { Youtube, Instagram, Facebook, Linkedin, Send } from "lucide-react";

// Central source of truth for KRV Prime social links (used in Footer, Contact, Assistant).
export const WHATSAPP_NUMBER = "919000004109";
export const WHATSAPP_LINK = "https://wa.me/919000004109?text=Hi%20KRV Prime%2C%20I%27d%20like%20to%20know%20more.";

export const SOCIALS = [
  { icon: Youtube, label: "YouTube", href: "https://www.youtube.com/@KRV Prime" },
  { icon: Instagram, label: "Instagram", href: "https://www.instagram.com/KRV Prime" },
  { icon: Facebook, label: "Facebook", href: "https://www.facebook.com/KRV Prime" },
  { icon: Linkedin, label: "LinkedIn", href: "" },
  { icon: Send, label: "Telegram", href: "https://t.me/KRV Prime" },
];
